export enum QueryType {
    Advanced = 'advanced',
    Basic = 'basic'
}